import { useIntl } from 'react-intl';
import { SearchIllustration } from '@tlx/atlas';
import { getContextId } from '@tlx/astro-shared';
import { TableEmptyState } from '@Component/Table/Table.utils.tsx';

export interface TableEmptyCreateSalaryProps {
    closestMonthPeriod: string;
}

export function TableEmptyCreateSalary({ closestMonthPeriod }: TableEmptyCreateSalaryProps) {
    const intl = useIntl();

    return (
        <TableEmptyState
            titleMessage={intl.formatMessage({
                id: 'tsk_filter_no_salary_payments',
            })}
            descriptionMessage={intl.formatMessage({
                id: 'tsk_filter_results_try_create_salary_payment',
            })}
            buttonContent={intl.formatMessage({
                id: 'tsk_text_create_salary_payment',
            })}
            illustration={<SearchIllustration size={'small'} />}
            onClickAction={() => {
                window.open(`/page/salary/create?${closestMonthPeriod}&contextId=${getContextId()}`);
            }}
        />
    );
}
